var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"aria-live":"assertive"}},[(_vm.message)?_c('span',{staticClass:"sr-only",domProps:{"textContent":_vm._s(_vm.message)}}):_c('span',{staticClass:"sr-only",domProps:{"innerHTML":_vm._s('&nbsp;')}})])}
var staticRenderFns = []

export { render, staticRenderFns }